import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { HumanReviewDialogData } from 'app/shared/models/blockage-prediction';

@Component({
    selector: 'app-hr-report-dialog',
    template: '<mat-dialog-content><app-human-review-report [dialogData]="data" [reportDate]="data.date" (closeDialog)="dialogRef.close($event)"></app-human-review-report></mat-dialog-content>',
    styles: [`
        .mat-dialog-content {
            margin: 0;
            padding: 0 24px;
        }
    `]
})

export class HumanReviewReportDialogComponent {
    
    constructor(
        public dialogRef: MatDialogRef<HumanReviewReportDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: HumanReviewDialogData
    ) { }
}
